import React, { useState } from 'react';
import './HeaderDash.css';
import ButonScreen from '../ButonScreen/ButonScreen';
import InputSearch from '../InputSearch/InputSearch';
import InfoUser from '../InfoUser/InfoUser';
import { Link as Anchor } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faSun, faMoon } from '@fortawesome/free-solid-svg-icons';
import QrGenerator from '../QrGenerator/QrGenerator';
import Estado from '../Estado/Estado';
import { useTheme } from '../../ThemeContext/ThemeContext';
export default function HeaderDash() {
    const { mode, toggleMode } = useTheme();


    return (
        <div className={`HeaderDashContain`}>
            <InputSearch />

            <div className='deFlexHeader'>
                <button className="theme-toggle-dash" onClick={toggleMode} title={mode === "dark" ? "Modo Claro" : "Modo Oscuro"}>
                    <FontAwesomeIcon icon={mode === "dark" ? faSun : faMoon} />
                </button>
                <ButonScreen />
                <Estado />
                <Anchor to={'/'} className='link'>
                    <FontAwesomeIcon icon={faHome} /> Tienda
                </Anchor>
                <QrGenerator />
                <InfoUser />
            </div>


        </div>
    );
}
